import styled from 'styled-components';
import { theme } from '../../../global';

export const CasesContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 840px;
  flex-direction: column;
  margin: auto;
  gap: ${theme.spacings.s32};
  padding: ${theme.spacings.s40} 0;

  @media (max-width: 900px) {
    width: 500px;
    padding: ${theme.spacings.s24} 0;
  }

  @media (max-width: 500px) {
    width: 343px;
    padding: ${theme.spacings.s24} 0;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${theme.spacings.s4};
`;

export const Title = styled.h1`
  font-family: 'Montserrat';
  font-weight: 700;
  font-size: 32px;
  line-height: 43.53px;

  @media (max-width: 900px) {
    font-size: 24px;
  }
`;

export const SubTitle = styled.h1`
  font-family: 'Montserrat';
  font-weight: 500;
  font-size: 16px;
  line-height: 19.5px;
  color: ${theme.colors.secondaryText};
`;

export const SearchWrapper = styled.div`
  width: 100%;
  & > span {
    font-family: 'Montserrat';
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    height: 52px;
    border: 1px solid ${theme.colors.lightPurple};
    border-radius: ${theme.spacings.s12};
    padding: ${theme.spacings.s12};
    gap: 10px;

    input::placeholder {
      color: ${theme.colors.lightPurple};
    }
  }
`;

export const TagsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacings.s8};
  width: 100%;
  flex-wrap: wrap;

  span {
    border: 0.94px solid ${theme.colors.lightPurple};
    border-radius: ${theme.spacings.s32};
    padding: ${theme.spacings.s8};
    font-family: 'Montserrat';
    font-weight: 500;
    font-size: 12px;
    line-height: 14.63px;
    color: #53555f;
    margin: 0;
    background-color: #A39EBF0A;
  }

  .ant-tag-checkable:not(.ant-tag-checkable-checked):hover {
    background-color: #a39ebf33;
    color: #53555f;
  }

  .ant-tag-checkable-checked {
    background: ${theme.colors.lightPurple};
    border: 0.94px solid ${theme.colors.lightPurple};
    border-radius: ${theme.spacings.s32};
    color: ${theme.colors.white};
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: ${theme.spacings.s8};
  }
`;

export const CasesCount = styled.span`
  font-family: 'Montserrat';
  font-weight: 600;
  font-size: 16px;
  line-height: 19.5px;
  color: ${theme.colors.secondaryText};
  text-transform: uppercase;
  width: 100%;
`;

export const CasesItemsWrapper = styled.div`
  flex-direction: column;
  width: 100%;
  display: flex;
  gap: ${theme.spacings.s24};
`;
